import { inIFrame } from '@thoughtspot/browser-util';
import _ from 'lodash';
export var ScreenSizeClass;
(function (ScreenSizeClass) {
    ScreenSizeClass[ScreenSizeClass["HD"] = 0] = "HD";
    ScreenSizeClass[ScreenSizeClass["FHD"] = 1] = "FHD";
    ScreenSizeClass[ScreenSizeClass["QHD"] = 2] = "QHD";
    ScreenSizeClass[ScreenSizeClass["UHD"] = 3] = "UHD";
})(ScreenSizeClass || (ScreenSizeClass = {}));
const hdScalingClassName = 'rd-scaling-hd';
const fhdScalingClassName = 'rd-scaling-fhd';
const qhdScalingClassName = 'rd-scaling-qhd';
const uhdScalingClassName = 'rd-scaling-uhd';
export const SCALING_CLASS_NAMES = [
    hdScalingClassName,
    fhdScalingClassName,
    qhdScalingClassName,
    uhdScalingClassName,
];
const DEBOUNCING_RESIZE_TIME = 60;
const ResponsiveBreakpoints = [
    {
        name: 'HD',
        screenSizeClass: ScreenSizeClass.HD,
        minWidth: 0,
        maxWidth: 1600,
        className: hdScalingClassName,
    },
    {
        name: 'FHD',
        screenSizeClass: ScreenSizeClass.FHD,
        minWidth: 1600,
        maxWidth: 1920,
        className: fhdScalingClassName,
    },
    {
        name: 'QHD',
        screenSizeClass: ScreenSizeClass.QHD,
        minWidth: 1920,
        maxWidth: 2560,
        className: qhdScalingClassName,
    },
    {
        name: 'UHD',
        screenSizeClass: ScreenSizeClass.UHD,
        minWidth: 2560,
        maxWidth: Infinity,
        className: uhdScalingClassName,
    },
];
let currentResponsiveClassName = '';
let scalingDisabled = false;
export function getResponsiveBreakpoint() {
    const screenWidth = inIFrame() ? window.innerWidth : window.outerWidth;
    const currentBreakpoint = ResponsiveBreakpoints.find(breakpoint => {
        return (screenWidth >= breakpoint.minWidth &&
            screenWidth <= breakpoint.maxWidth);
    });
    return currentBreakpoint;
}
function updateBreakpointClass() {
    const oldResponsiveClassName = currentResponsiveClassName;
    const currentBreakpoint = getResponsiveBreakpoint();
    currentResponsiveClassName = currentBreakpoint.className;
    if (oldResponsiveClassName)
        document.documentElement.classList.remove(oldResponsiveClassName);
    document.documentElement.classList.add(currentResponsiveClassName);
}
const debouncedResizeHandler = _.debounce(() => {
    updateBreakpointClass();
}, DEBOUNCING_RESIZE_TIME);
export function initializeScaling() {
    scalingDisabled = false;
    updateBreakpointClass();
    window.addEventListener('resize', debouncedResizeHandler);
}
export function terminateScaling(disableScaling = false) {
    scalingDisabled = disableScaling;
    if (currentResponsiveClassName)
        document.documentElement.classList.remove(currentResponsiveClassName);
    currentResponsiveClassName = '';
    debouncedResizeHandler.cancel();
    window.removeEventListener('resize', debouncedResizeHandler);
}
export function resumeScalingIfNeeded() {
    if (scalingDisabled) {
        initializeScaling();
    }
}
export function disableScalingIfNeeded() {
    if (currentResponsiveClassName) {
        terminateScaling(true);
    }
}
//# sourceMappingURL=scaling-service.js.map